import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api/api.service';
import { ApiResponse } from '@interfaces/response';
import { Device } from '@interfaces/device';

@Injectable({
  providedIn: 'root'
})
export class DevicesApiService {
  private api_service = inject(ApiService);
  private devices_url: string = '/devices/';

  public get_devices_list(showLoader: boolean = true): Observable<ApiResponse<Device[]>> {
    return this.api_service.get<ApiResponse<Device[]>>(this.devices_url, undefined, undefined, showLoader);
  }

  public create_device(device: Partial<Device>): Observable<ApiResponse<Device>> {
    return this.api_service.post<ApiResponse<Device>>(this.devices_url, device);
  }

  public update_device(id: number, changes: Partial<Device>): Observable<ApiResponse<Device>> {
    return this.api_service.patch<ApiResponse<Device>>(`${this.devices_url}${id}`, changes);
  }

  public delete_device(id: number): Observable<ApiResponse<null>> {
    return this.api_service.delete<ApiResponse<null>>(`${this.devices_url}${id}`);
  }
}
